import React from "react";
import useLocalStorage from "../hooks/useLocalStorage";
import GaussianIqDisplay from "./GaussianIqDisplay";

/**
 * Component to display IQ estimate with toggle checkbox
 * @param {object} props - Component props
 * @param {number} props.iqEstimate - The IQ estimate to display
 * @param {string} props.question - The question text to display
 */
const IqEstimateDisplay = ({ iqEstimate, question }) => {
  const [showIqEstimate, setShowIqEstimate] = useLocalStorage(
    "showIqEstimate",
    true
  );

  if (!iqEstimate) return null;

  return (
    <div className="mb-4 p-4 bg-blue-50 dark:bg-blue-900 rounded-lg shadow-sm">
      <div className="flex items-center mb-3">
        <div className="flex items-center mr-3">
          <input
            id="show-iq-estimate"
            type="checkbox"
            checked={showIqEstimate}
            onChange={() => setShowIqEstimate(!showIqEstimate)}
            className="w-4 h-4 mr-2 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
          />
          {!showIqEstimate ? (
            <label
              htmlFor="show-iq-estimate"
              className="text-sm text-gray-600 dark:text-gray-400"
            >
              Show IQ estimate
            </label>
          ) : (
            <span className="text-xl font-bold text-blue-700 dark:text-blue-300">
              IQ Estimate
            </span>
          )}
        </div>
        {showIqEstimate && (
          <div className="text-sm text-blue-600 dark:text-blue-400">
            Approximate intelligence quotient of the question (just for fun!)
          </div>
        )}
      </div>

      {showIqEstimate && (
        <div className="mt-4">
          <GaussianIqDisplay iqScore={iqEstimate} question={question} />
        </div>
      )}
    </div>
  );
};

export default IqEstimateDisplay;
